import { MaterialTableColumn } from "shared/components/materialTable/types";
import { useCopies } from "shared/hooks/useCopies";
import { ApiBulkTicket } from "../../../types";
import React from "react";
import DateTimeDisplayCell from "apps/console/components/emailSnippet/components/dateTimeDisplayCell";
import Button from "shared/components/button";
import Variant from "shared/enums/Variant";
import ToolTip from "shared/components/tooltip";
import Size from "shared/enums/Size";

export function useColumnsForBulkTicketsTransferViewMode(): Array<MaterialTableColumn<ApiBulkTicket>> {
  const copies = useCopies();
  const columns = React.useMemo(() => {
    let cols: Array<MaterialTableColumn<ApiBulkTicket>> = [
      {
        name: copies.get("quantity"),
        className: "blk_col_qty",
        Cell: item => {
          return <div>{item.ticketsPurchased}</div>;
        }
      },
      {
        name: copies.get("bulk.ticket.table.column.assigned.count"),
        className: "blk_col_assignedTo",
        Cell: item => {
          if (!item.assignedTickets?.length) {
            return copies.get("join.by.hyphen");
          }
          return (
            <React.Fragment>
              <div className="blk_col_assignedToCount">
                <Button.Custom
                  variant={Variant.LINK}
                  title={copies.get("view")}
                  tooltipContent={item.assignedTickets.map(ticket => {
                    return <div>{ticket.name}</div>;
                  })}>
                  {copies.get("view")} <span>({item.assignedTickets.length})</span>
                </Button.Custom>
              </div>
            </React.Fragment>
          );
        }
      },
      {
        name: copies.get("bulk.ticket.assigned.by"),
        className: "blk_col_assignedBy",
        Cell: item => {
          if (item.transfers?.length === 0) {
            return (
              <span className="blk_col_assignedByName" title={copies.get("bulk.ticket.source.self")}>
                <span className="blk_col_assignedByName--text">{copies.get("bulk.ticket.source.self")}</span>
              </span>
            );
          }
          const transferedFrom = item.transfers?.[0]?.fromName;
          const consoleUserName = item.transfers?.[0]?.consoleUserName;
          return (
            <span className="blk_col_assignedByName">
              <span className="blk_col_assignedByName--text">{transferedFrom}</span>
              {!!consoleUserName && (
                <ToolTip
                  size={Size.EXTRA_SMALL}
                  content={copies.get("bulk.ticket.source.admin.tooltip", {
                    0: consoleUserName
                  })}
                />
              )}
            </span>
          );
        }
      },
      {
        name: copies.get("bulk.ticket.purchased.on"),
        className: "blk_col_purchasedOn",
        Cell: item => {
          return <DateTimeDisplayCell date={item.purchasedOn} />;
        }
      }
    ];
    return cols;
  }, [copies]);
  return columns;
}
